<script setup lang="ts">
const { locale } = useI18n()
const tenant = useTenant()
const auth = useAuth()

await callOnce(async () => {
  await Promise.all([tenant.resolveTenant(), auth.init()])
})

useHead(() => ({
  htmlAttrs: {
    lang: locale.value
  },
  meta: [{ name: 'viewport', content: 'width=device-width, initial-scale=1' }],
  link: [{ rel: 'icon', href: '/favicon.ico' }]
}))
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
  <ClientOnly>
    <SharedConfirmDialog />
  </ClientOnly>
</template>
